<div class="flex gap align-items-center">
    <div class="headerText">{{ 'individualPlan.fields.offers' | translate }}</div>
    <app-switch-input
        id="showAllOffers"
        [form]="form"
        label="individualPlan.message.showAllOffers"
    ></app-switch-input>
</div>

<app-social-service-select-offer
    [form]="form"
    [serviceId]="store.globalGlobalStore.loggedUserStore.selectedServiceId() || 0"
    id="offers"
    [allowedTypes]="allowedTypes()"
    [showOperations]="false"
    [showApplications]="false"
    [showSelectedItems]="false"
    [additionalFilter]="additionalOffersFilter()"
    [disabled]="disabled()"
    (selectedOffer)="addOffer($event)"
    label="individualPlan.message.addProcedure"
></app-social-service-select-offer>

<app-table
    tableKey="socialServiceOffersInput"
    translatePrefix="individualPlan.procedure."
    [columns]="offerColumns()"
    [items]="visibleOfferForms()"
    [hideCheckboxes]="true"
    [showDetail]="false"
    [showPagination]="false"
    [showColumnVisiblity]="true"
    [rows]="9999"
    selectionMode="single"
    dataKey="value.offerId"
    [rowExpansion]="rowExpansion"
    (deleteCallback)="removeOffer($event)"
>
    <ng-template pTemplate="dateFrom" let-item="item">
        <app-date-input
            [form]="item"
            id="dateFrom"
        ></app-date-input>
    </ng-template>

    <ng-template pTemplate="dateTo" let-item="item">
        <app-date-input
            [form]="item"
            id="dateTo"
        ></app-date-input>
    </ng-template>

    <ng-template pTemplate="code" let-item="item">
        @let offer = offersData()?.[item?.value?.offerId || ''];
        <p-chip
            [label]="offer.code"
            [pTooltip]="offer.name"
            [ngStyle]="{ 'background-color': offer.color || DEFAULT_TAG_COLOR, 'border-radius': '16px', color: (offer.color || DEFAULT_TAG_COLOR) | colorContrast }"
        ></p-chip>
    </ng-template>

    <ng-template pTemplate="name" let-item="item">
        <app-strip-and-show
            [text]="offersData()?.[item?.value?.offerId || '']?.name || ''"
            [length]="50"
        ></app-strip-and-show>
    </ng-template>

    <ng-template pTemplate="unit" let-item="item">
        @let unit = offersData()?.[item?.value?.offerId || '']?.unit;
        @if (unit) {
            {{ 'enum.measurementUnit.' + unit | translate }}
        }
    </ng-template>

    <ng-template pTemplate="noRecord" let-item="item">
        @let noRecord = offersData()?.[item?.value?.offerId || '']?.noRecord;
        @if (noRecord !== null && noRecord !== undefined) {
            {{ 'common.trueFalseEnum.' + noRecord | translate }}
        }
    </ng-template>

    <ng-template pTemplate="usualTime" let-item="item">
        <div class="flex gap-small align-items-center">
            @let offer = offersData()?.[item?.value?.offerId || ''];
            <app-number-input
                [class]="'usualTime ' + (!offer || offer.restTime <= 0 ? 'usualTime-full' : '')"
                [form]="item"
                [min]="0"
                id="usualTime"
                label="individualPlan.procedure.fields.usualTimeLength"
                (selectedValueChange)="usualTimeChange(item, $event)"
            ></app-number-input>
            @if (offer && offer.restTime > 0) {
                <app-number-input
                    class="restTime"
                    [form]="item"
                    id="restTime"
                    prefix="individualPlan.procedure."
                    [prefixChar]="item.value.restTime > 0 ? '+' : ''"
                    [showLabel]="false"
                    [min]="0"
                    [clear]="true"
                    [pTooltip]="'individualPlan.procedure.messages.capacityNotAvailable' | translate"
                ></app-number-input>
            }
        </div>
    </ng-template>

    <ng-template pTemplate="frequency" let-item="item">
        <app-text-input
            [form]="item"
            id="frequency"
            label="individualPlan.procedure.fields.frequencyShort"
        ></app-text-input>
    </ng-template>

    <ng-template #rowExpansion let-item="item">
        @let offerId = item?.value?.offerId || '';
        @let offerData = offersData()?.[offerId];
        <div class="flex flex-column gap pl-5 justify-content-start">
            @for (operation of (offerData?.operations || []); track operation.id) {
                <app-check-input
                    class="align-self-start"
                    #operationCheck
                    [attributes]="{ id: operation.id, offerId: offerData.id, type: 'operations' }"
                    [id]="operation.id"
                    [label]="operation.name"
                    [readonly]="disabled()"
                    [class.readonly]="disabled()"
                    (selectedValueChange)="selectedOp(offerData.id, operation.id, 'operations')"
                ></app-check-input>
            }
            @for (procedure of offerData?.procedures; track procedure.id) {
                <app-check-input
                    class="align-self-start"
                    #procedureCheck
                    [attributes]="{ id: procedure.id, offerId: offerData.id, type: 'procedures' }"
                    [id]="procedure.id"
                    [label]="procedure.name"
                    [readonly]="disabled()"
                    [class.readonly]="disabled()"
                    (selectedValueChange)="selectedOp(offerData.id, procedure.id, 'procedures')"
                ></app-check-input>
            }
        </div>
    </ng-template>

</app-table>
